<template>
  <div>
    <v-form ref="finalForm" v-model="formValidationState" @keydown.enter.prevent lazy-validation>
      <p class="subheading">
        Vertragsdaten
      </p>
      <v-flex xs12>
        <v-menu v-model="beginFieldMenu" :close-on-content-click="false" :nudge-right="40" lazy
          transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="beginFormatted" readonly label="Beginn der Versicherung*" prepend-icon="event" hint=""
              required persistent-hint v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="begin" no-title locale="de" show-week :allowed-dates="allowedDatesForBegin"
            @input="beginFieldMenu = false"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-divider></v-divider>

      <p class="subheading mt-3 mb-0">
        Kontaktdaten
      </p>
      <v-radio-group row v-model="salutation">
        <v-radio label="Herr" value="1"></v-radio>
        <v-radio label="Frau" value="2"></v-radio>
      </v-radio-group>
      <v-text-field v-model="name" :rules="defaultRules" label="Vorname*" required></v-text-field>
      <v-text-field v-model="lastname" :rules="defaultRules" label="Nachname*" required></v-text-field>
      <v-text-field v-model="street" :rules="defaultRules" label="Straße*" required></v-text-field>
      <v-text-field v-model="housenr" :rules="defaultRules" label="Hausnummer*" required></v-text-field>
      <v-text-field v-model="zip" :rules="[zipRulesExtended]" label="Postleitzahl*" mask="#####" required></v-text-field>
      <v-text-field v-model="city" :rules="defaultRules" label="Ort*" required></v-text-field>
      <!--
        <v-text-field
                v-model="birthdate"
                :rules="birthdateRules"
                label="Geburtsdatum"
                placeholder="TT.MM.JJJJ"
                mask="##.##.####"
                required
        ></v-text-field>
        -->
      <v-flex xs12>
        <v-menu ref="birthdateFieldMenuRef" v-model="birthdateFieldMenu" :close-on-content-click="false" :nudge-right="40"
          lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="birthdateFormatted" ref="birthdateField" readonly required label="Geburtsdatum*"
              :messages="birthdateRequiredMessage" :rules="birthdateRules" prepend-icon="event" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="birthdate" ref="birthdatePicker" locale="de" :max="youngestPossibleBirthdate"
            min="1900-01-01" :allowed-dates="allowedDatesForBirthdate" @change="saveBirthdate"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-text-field v-model="email" ref="email" :rules="emailRules" label="Mail*" required></v-text-field>
      <v-text-field v-model="emailRepeated" :rules="emailRepeatedRules" :error-messages='checkEmailRepeated()'
        label="Mail bestätigen" required @blur="checkEmailRepeated"></v-text-field>
      <v-text-field v-model="phone" label="Telefonnummer (optional)"></v-text-field>

      <div v-if="agencySearchOptionIsAppropriate">
        <v-divider></v-divider>
        <p class="subheading mt-3 mb-0">
          Mein Ansprechpartner vor Ort <span v-if="salesagent_nr === ''">
            <v-icon @click.prevent.stop="showAgencySearchInfoDialog = true"
              style="border-radius:50%;background-color:#6682c9;vertical-align: bottom;margin-left: 0.5em;" color="white">
              info_outline
            </v-icon>
          </span>
        </p>
        <!-- Search dialog -->
        <div v-if="salesagent_nr === ''">

          <v-radio-group row v-model="searchMethod" @change="resetSearch" @click="resetSearch">
            <v-radio label="Suche nach Namen" value="BY_NAME"></v-radio>
            <v-radio label="Suche nach Ort" value="BY_LOCATION"></v-radio>
          </v-radio-group>
          <p>
            Sie haben bereits einen Ansprechpartner und möchten diesen gezielt suchen?
          </p>
          <v-autocomplete hide-no-data hide-details clearable :loading="isLoading" v-model="query"
            :label="searchFieldLabel" :items="entries" :search-input.sync="search" @click:clear="resetSearch"
            @input="registerInputEvent" @change="logChangeEvent"
            @update:search-input="logUpdateSearchInputEvent"></v-autocomplete>

          <p>
            Andernfalls wählen Sie gerne einen Ansprechpartner in Ihrer Nähe.
          </p>

          <!-- agencyCarousel -->
          <v-container fluid grid-list-lg class="pl-0">
            <v-layout row wrap>
              <v-flex xs6 sm3 md2 v-for="agency in agencies" :key="agency.agn">
                <agency-card :source=agency.imageUrl :label="agency.overlayText" :description="agency.shortDescription"
                  :agn="agency.agn" mode="selectable" @agencyCardClicked="agencyCardClicked">
                </agency-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <!-- Result of search dialog: selected agency -->
        <div v-show="salesagent_nr !== '' && $store.state.work.internal.selectedAgency !== null">
          <v-container fluid class="pa-0 ma-0 my-2">
            <v-layout row wrap>
              <v-flex xs12 sm8>
                <v-card class="agency-card" elevation="3" color="transparent">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12 sm4>
                        <v-img :src="$store.state.work.internal.selectedAgency.imageUrl" position="left top"
                          contain></v-img>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-card-text class="p-no-bottom-margin"
                          v-html="$store.state.work.internal.selectedAgency.shortDescription">
                        </v-card-text>
                      </v-flex>
                      <v-flex xs12>
                        <v-card-actions class="px-0 py-1">
                          <v-btn block small color="primary" @click.stop="resetSalesAgent">Anderen Ansprechpartner
                            wählen</v-btn>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>
                  </v-container>

                </v-card>
              </v-flex>


            </v-layout>
          </v-container>
        </div>


        <!-- End of agency search -->
        <v-divider></v-divider>
      </div>


      <p class="subheading mt-3 mb-0">
        Kontodaten
      </p>

      <v-text-field ref="ibanField" v-model="iban" :rules="ibanRules" label="IBAN*" placeholder="DE..."
        mask="DE##-####-####-####-####-####-####-####-##"
        @blur="checkIban(); showIbanRequiredDialog = !ibanValidationState;" required></v-text-field>
      <v-checkbox v-model="sepa" :rules="[v => !!v || 'Wir benötigen Ihr Einverständnis!']"
        label="SEPA Lastschriftmandat erteilen" required></v-checkbox>
      <div class="xs12" style="height:3em;">
        <v-btn class="right" dark color="cta" @click="showSummary">
          Zur Zusammenfassung
        </v-btn>
      </div>

      <!--
    <v-btn
            class="right"
            dark
            color="grey"
            @click="$emit('showSummary')"
    >
      TESTHILFE: weiter ohne Plausibilisierung
    </v-btn>
-->

    </v-form>
    <v-dialog max-width="350px" class="dialog-width" persistent v-model="showBirthdateConflict">
      <v-card>
        <v-toolbar dark color="primary lighten-1">
          <v-toolbar-title>ACHTUNG!</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showBirthdateConflict = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p>
            Die Alterseingabe weicht von dem eingegebenen Geburtsdatum ab. Der Beitrag wurde angepasst.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn class="primary" @click="showBirthdateConflict = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="350px" class="dialog-width" persistent v-model="showIbanRequiredDialog">
      <v-card>
        <v-toolbar dark color="primary lighten-1">
          <v-toolbar-title>IBAN</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="hideIbanRequiredDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p>
            Die angegebene IBAN ist keine gültige IBAN. Bitte Eingabe prüfen.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn class="primary" @click="hideIbanRequiredDialog">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="350px" class="dialog-width" v-model="showAgencySearchInfoDialog">
      <v-card>
        <v-toolbar dark color="#002EA7">
          <v-toolbar-title>Info</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.stop="showAgencySearchInfoDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p>Sie haben keinen Betreuer für Ihren Vertrag ausgewählt. Um Sie auch nach Abschluss des Vertrages
            bestmöglich beraten zu können, geben wir die weitere Betreuung des Vertrages in die bewährten Hände eines
            unserer Vertriebspartner, der in Ihrer Nähe zu finden ist.</p>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Vue from "vue";
import AgencyCard from "./AgencyCard";
// import OevAgencyService from "../services/OevAgencyService";
import { getSuggestionList, getAgencyList } from "../services/AgencySearchService";
import { mapGetters } from "vuex";
import { postGaMessage } from "@/stores/modules/ga";

export default {
  name: "FormOfferRequest",
  components: { AgencyCard },
  computed: {
    agencySearchOptionIsAppropriate() {
      // return (this.kanalType !== 'agn' && !this.isOnlineGs); // siehe Mail Diekena vom 21.3.23, 10:56
      return this.kanalType !== "agn";
    },
    selectedAgencyShortDescription() {
      if (this.selectedAgency !== null) {
        return this.selectedAgency.shortDescription;
      }
      else { return "" };
    },
    selectedAgencyImageUrl() {
      if (this.selectedAgency !== null) {
        return this.selectedAgency.imageUrl;
      }
      else { return "" };
    },
    emailEquality() {
      return (this.email.toLowerCase() == this.emailRepeated.toLowerCase());
      // return this.email == this.emailRepeated;
    },
    bbanFormatted() {
      if (this.bban.length > 0) {
        return "<span style='font-size:smaller;'>BLZ: " + this.bban + "</span>";
      }
      return "";
    },
    beginFormatted() {
      return this.begin
        ? this.moment(this.begin)
          .locale("de")
          .format("dddd, D. MMM YYYY")
        : "";
    },
    begin: {
      get() {
        if (
          this.$store.state.work.forxchange.offerRequest.contract.beginn == ""
        ) {
          this.$store.commit(
            "work/SET_CONTRACT_BEGIN",
            this.moment(this.tomorrow)
              .locale("de")
              .format("YYYY-MM-DD")
          );
        }
        return this.$store.state.work.forxchange.offerRequest.contract.beginn; // || this.tomorrow;
      },
      set(value) {
        this.$store.commit("work/SET_CONTRACT_BEGIN", value);
      }
    },
    salutation: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .salutation;
      },
      set(value) {
        this.$store.commit("work/SET_PH_SALUTATION", value);
      }
    },
    name: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder.name;
      },
      set(value) {
        this.$store.commit("work/SET_PH_NAME", value);
      }
    },
    lastname: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .lastname;
      },
      set(value) {
        this.$store.commit("work/SET_PH_LASTNAME", value);
      }
    },
    street: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .street;
      },
      set(value) {
        this.$store.commit("work/SET_PH_STREET", value);
      }
    },
    housenr: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .housenr;
      },
      set(value) {
        this.$store.commit("work/SET_PH_HOUSENR", value);
      }
    },
    zip: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder.zip;
      },
      set(value) {
        this.$store.commit("work/SET_PH_ZIP", value);
      }
    },
    city: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder.city;
      },
      set(value) {
        this.$store.commit("work/SET_PH_CITY", value);
      }
    },
    birthdateFormatted() {
      if (this.birthdate == "") { return ""; }
      return this.moment(this.birthdate)
        .locale("de")
        .format("D. MMM YYYY"); // : this.moment(this.tomorrow).subtract(this.minAge,'years').locale('de').format('dddd, D. MMM YYYY');
    },
    birthdate: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder.birthdate;
      },
      set(value) {
        this.$store.commit("work/SET_PH_BIRTHDATE", value);
      }
    },
    email: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .email;
      },
      set(value) {
        this.$store.commit("work/SET_PH_EMAIL", value);
      }
    },
    emailRepeated: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .emailRepeated;
      },
      set(value) {
        this.$store.commit("work/SET_PH_EMAILREPEATED", value);
      }
    },
    phone: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder
          .phone;
      },
      set(value) {
        this.$store.commit("work/SET_PH_PHONE", value);
      }
    },
    searchFieldLabel() {
      return (this.searchMethod === 'BY_NAME') ? 'Name eingeben ...' : 'Ort eingeben ...';
    },
    iban: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.policyholder.iban;
      },
      set(value) {
        this.$store.commit("work/SET_PH_IBAN", value);
      }
    },
    sepa: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.properties.sepa;
      },
      set(value) {
        this.$store.commit("work/SET_PH_SEPA", value);
      }
    },
    valid() {
      return this.skValidate();
    },
    minAge() {
      return this.isOnlineGs ? 16 : 18;
    },
    ...mapGetters("work", {
      salesagent_nr: "getSalesAgentNr",
      kanalType: "getKanalType",
      isOnlineGs: "getIsOnlineGs"
    })
  },
  data: () => ({
    self: this,
    formValidationState: false,
    ibanValidationState: false,
    showIbanRequiredDialog: false,
    showAgencySearchInfoDialog: false,
    tomorrow: new Date(),
    youngestPossibleBirthdate: new Date(),
    beginFieldMenu: false,
    birthdateFieldMenu: false,
    showBirthdateConflict: false,
    birthdateRequiredMessage: "",
    searchMethod: 'BY_NAME',
    query: null,
    search: null,
    suggestions: [],
    entries: [],
    agencies: [],
    selectedAgency: null,
    isLoading: false,
    suggestionClicked: false,
    bban: "",
    beginRules: [v => !!v || "Der Versicherungsbeginn wird benötigt!"],
    defaultRules: [v => !!v || "Diese Angabe wird benötigt!"],
    zipRules: [
      v => !!v || "Die Postleitzahl wird benötigt.",
      v => /[0-9]{5,5}/.test(v) || "Die Postleitzahl muss fünfstellig sein.",
      (plz, self) => ((self.$store.state.work.ignoreZipCodeCheck == true) ||
        (plz == 38179) ||
        (plz >= 38440 && plz <= 38448) ||
        (plz >= 38465 && plz <= 38559) ||
        (plz == 31061 || plz == 31073) ||
        (plz >= 31091 && plz <= 31167) ||
        (plz >= 31224 && plz <= 31241) ||
        (plz == 31867 || plz == 31868) ||
        (plz >= 37441 && plz <= 37539) ||
        (plz >= 37547 && plz <= 37589) ||
        (plz >= 37603 && plz <= 37699) ||
        (plz >= 38100 && plz <= 38126) ||
        (plz == 38154 || plz == 38159 || plz == 38165 || plz == 38176) ||
        (plz >= 38226 && plz <= 38259) ||
        (plz == 38268) ||
        (plz >= 38350 && plz <= 38388) ||
        (plz >= 38456 && plz <= 38464) ||
        (plz >= 38640 && plz <= 38729) ||
        (plz == 27321) ||
        (plz == 31863 || plz == 38162) ||
        (plz >= 38170 && plz <= 38173) ||
        (plz >= 38271 && plz <= 38279) ||
        (plz >= 38300 && plz <= 38304) ||
        (plz >= 38312 && plz <= 38329)
      ) || 'Die Postleitzahl ' + plz + ' liegt leider außerhalb unseres Geschäftsgebietes!'

    ],
    emailRules: [
      v => !!v || "Die E-Mailadresse wird benötigt.",
      v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "Ungültige E-Mailadresse!"
    ],
    emailRepeatedRules: [
      v => !!v || "Die Wiederholung der E-Mailadresse wird benötigt.",
      v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "Ungültige E-Mailadresse!"
    ],
    birthdateRules: [v => !!v || "Das Geburtsdatum wird benötigt!"],
    ibanRules: [v => !!v || "Die IBAN wird benötigt!"]
  }),
  mounted() {
    this.tomorrow = this.getInitialDate();
    this.$store.commit("work/SET_CONTRACT_BEGIN",
      this.moment(this.tomorrow).locale("de").format("YYYY-MM-DD")
    );
    this.youngestPossibleBirthdate = this.moment(this.tomorrow)
      .subtract(this.minAge, "years")
      .format("YYYY-MM-DD");
  },
  watch: {
    birthdateFieldMenu(val) {
      val &&
        setTimeout(() => (this.$refs.birthdatePicker.activePicker = "YEAR"));
    },
    search(val) {
      if (val === '') {
        this.resetSearch();
        return;
      }
      if (this.isLoading) return;
      this.isLoading = true;
      val && val !== this.query && this.callBeratersucheApi(val);
    }
  },
  methods: {
    saveBirthdate(date) {
      let realAgeGroup = 0;
      let age = this.moment(this.tomorrow).diff(this.moment(date), 'years');
      if (age >= this.minAge && age <= 30) { realAgeGroup = 1; }
      if (age > 30) { realAgeGroup = 2; }
      if (realAgeGroup !== this.$store.getters['work/getSupposedlyAgeGroup']) {
        this.showBirthdateConflict = true;
        // TODO: ggf. weitere Maßnahmen
        // SET_SUPPOSEDLY_AGEGROUP
        // CALCULATE_TOTAL_PRICE
        this.$store.commit("work/SET_SUPPOSEDLY_AGEGROUP", realAgeGroup);
        this.$store.commit("work/CALCULATE_TOTAL_PRICE");
      }
      this.$refs.birthdateFieldMenuRef.save(date);
    },
    resetSearch() {
      this.selectedAgency = null;
      this.resetSalesAgent();
      this.query = null;
      this.search = null;
      Vue.set(this.suggestions, 'length', 0);
      Vue.set(this.entries, 'length', 0);
      Vue.set(this.agencies, 'length', 0);
      this.suggestions = [];  // test
      this.entries = [];
      this.agencies = [];
      this.isLoading = false;
      this.suggestionClicked = false;
    },
    registerInputEvent() {
      this.suggestionClicked = true
    },
    logChangeEvent() {
      // console.log("change event occured");
      let self = this;
      if (this.suggestionClicked == true) {
        getAgencyList(this.searchMethod, this.query)
          .then(function (response) {
            self.agencies = response.branches;
            self.isLoading = false;
            self.suggestionClicked = false;
          })
          .catch(error => console.log('error', error));
      }
    },
    logUpdateSearchInputEvent() {
      // console.log("update:search-input event occured");
    },
    callBeratersucheApi() {
      let self = this;
      // console.log("callBeratersucheApi sagt jetzt: this.suggestionClicked = "+this.suggestionClicked);
      if (this.suggestionClicked == true) {
        getAgencyList(this.searchMethod, this.query)
          .then(function (response) {
            self.agencies = response.branches;
            self.isLoading = false;
            self.suggestionClicked = false;
          })
          .catch(error => console.log('error', error));
      }
      else {
        getSuggestionList(this.searchMethod, this.search)
          .then(function (response) {
            if (response.suggestions.length > 0) {
              self.entries = response.suggestions.filter(suggestion => suggestion.match(/_LABEL/g) === null);
              self.isLoading = false;
              self.suggestionClicked = false;
            }
          })
          .catch(error => console.log('error', error));
      }
    },
    agencyCardClicked(agn) {
      this.$store.commit("work/SET_SALESAGENT_NR", agn);
      this.selectedAgency = this.agencies.find(obj => obj.agn == this.salesagent_nr);
      this.$store.commit("work/SET_SELECTED_AGENCY_NUMBER", agn);
      this.$store.commit("work/SET_SELECTED_AGENCY_SHORT_DESCRIPTION", this.selectedAgency.shortDescription);
      this.$store.commit("work/SET_SELECTED_AGENCY_IMAGE_URL", this.selectedAgency.imageUrl);
    },
    resetSalesAgent() {
      this.$store.commit("work/SET_SALESAGENT_NR", '');
      this.$store.commit("work/SET_SELECTED_AGENCY_NUMBER", '');
      this.$store.commit("work/SET_SELECTED_AGENCY_SHORT_DESCRIPTION", '');
      this.$store.commit("work/SET_SELECTED_AGENCY_IMAGE_URL", '');
      this.selectedAgency = null;
    },
    hideIbanRequiredDialog() {
      this.showIbanRequiredDialog = false;
      // this.$refs.ibanField.$el.querySelector('input').focus();
      this.$nextTick(() => {
        this.$refs.ibanField.$el.querySelector('input').focus();
      });
    },
    checkIban(e) {
      let targetValue = this.$refs.ibanField.$el.querySelector('input').value;
      const cleanBan = targetValue.replace("-", "");
      let ok = this.IBAN.isValid(cleanBan); // e.target.value);
      // this.showIbanRequiredDialog = !ok;
      this.ibanValidationState = ok;
      if (ok) {
        this.bban = this.IBAN.toBBAN(cleanBan, ", Kontonummer: ");
      }
      else {
        this.bban = "";
        // this.ibanValidationState = false;
      }
    },
    checkEmailRepeated() {
      if (this.email.toLowerCase() != this.emailRepeated.toLowerCase()) {
        this.formValidationState = false;
        return 'Die E-Mailadressen stimmen nicht überein!';
      }
      return "";
    },
    skValidate() {
      if (this.$refs.finalForm == undefined) return false;
      let valid = this.$refs.finalForm.validate();
      valid = valid && this.ibanValidationState && this.emailEquality;

      this.birthdateRequiredMessage = "";
      if (this.birthdate == "") {
        // this.birthdateRequiredMessage = "Geburtsdatum wird benötigt!";
        this.formValidationState = false;
        this.$vuetify.goTo(this.$refs.birthdateField);
        return false;
      }

      this.formValidationState = valid;
      return valid;
    },
    reset() {
      this.$refs.finalForm.reset();
    },
    resetValidation() {
      this.$refs.finalForm.resetValidation();
    },
    showSummary() {
      // prüfe sicherheitshalber nochmal die IBAN
      this.checkIban();
      if (!this.ibanValidationState && this.$refs.finalForm.validate()) {
        this.showIbanRequiredDialog = true;
        this.$nextTick(() => {
          this.$refs.ibanField.$el.querySelector('input').focus();
        });
        return;
      }
      // Zeige die Zusammenfassung an
      if (this.skValidate()) {
        this.$emit("showSummary");
        postGaMessage('nextStep', 'Zur Zusammenfassung: Angaben vollständig')
      }
      else {
        postGaMessage('nextStep', 'Zur Zusammenfassung: Angaben unvollständig')
      }
    },
    allowedDatesForBegin(val) {
      return (
        val >= this.tomorrow &&
        this.moment(val) <= this.moment(this.tomorrow).add(5, "weeks")
      );
    },
    allowedDatesForBirthdate(val) {
      return (
        this.moment(val) <= this.moment(this.tomorrow).subtract(this.minAge, "years")
      );
    },
    getInitialDate() {
      // Initial date is tomorrow
      return this.moment(new Date()).add(1, 'days').format("YYYY-MM-DD");
      /*
      let d = new Date();
      d.setDate(d.getDate() + 1);
      return d.toISOString().substr(0, 10);

       */
    },
    zipRulesExtended(plz) {
      if (this.$store.state.work.ignoreZipCodeCheck == true) return true;
      if (plz == '') return "Die Postleitzahl wird benötigt.";
      if (/[0-9]{5,5}/.test(plz) == false) return "Die Postleitzahl muss fünfstellig sein.";
      if (!(
        (plz == 38179) ||
        (plz >= 38440 && plz <= 38448) ||
        (plz >= 38465 && plz <= 38559) ||
        (plz == 31061 || plz == 31073) ||
        (plz >= 31091 && plz <= 31167) ||
        (plz >= 31224 && plz <= 31241) ||
        (plz == 31867 || plz == 31868) ||
        (plz >= 37441 && plz <= 37539) ||
        (plz >= 37547 && plz <= 37589) ||
        (plz >= 37603 && plz <= 37699) ||
        (plz >= 38100 && plz <= 38126) ||
        (plz == 38154 || plz == 38159 || plz == 38165 || plz == 38176) ||
        (plz >= 38226 && plz <= 38259) ||
        (plz == 38268) ||
        (plz >= 38350 && plz <= 38388) ||
        (plz >= 38456 && plz <= 38464) ||
        (plz >= 38640 && plz <= 38729) ||
        (plz == 27321) ||
        (plz == 31863 || plz == 38162) ||
        (plz >= 38170 && plz <= 38173) ||
        (plz >= 38271 && plz <= 38279) ||
        (plz >= 38300 && plz <= 38304) ||
        (plz >= 38312 && plz <= 38329)
      )) return 'Die Postleitzahl ' + plz + ' liegt leider außerhalb unseres Geschäftsgebietes!';
      return true;
    }
  }
};
</script>

<style>
div.card.agency-card {
  /* padding: 0.5em; */
  width: 100%;
}

div.p-no-bottom-margin p {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
</style>
